// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","443":"about","529":"dynamics","686":"introduction","895":"download","974":"head"}[chunkId] + "." + {"18":"eabee42a","443":"4adf8323","529":"e3010c62","686":"c80eba9c","895":"08df7045","974":"7eddad5a"}[chunkId] + ".js";
};